import { render, staticRenderFns } from "./Management-Team.vue?vue&type=template&id=11e0bcd2"
import script from "./Management-Team.vue?vue&type=script&lang=js"
export * from "./Management-Team.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports